// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {
    $(document).ready(function () {

        //will check if the Sticky Product Menu is present and, only then, create the functions and events
        if ($('.sticky_buy').length > 0) {

            //menu, placeholder (to avoid "jumping") and positioning
            var $obj = $('.sticky_buy');
            var $obj_place = $('.sticky_placeholder');
            var top = $obj_place.offset().top;
        
            //mobile?
            var mobile = ($(window).width() < 768) ? true : false;

            //if it's not mobile, duplicate in the anchor menu
            function moveSticky() {
                if (!mobile) {
                    $obj.removeClass('fixed');
                    var $anchor_m = $(".anchormenusectionfix.sticky-product-container ul.menu.anchormenu");
                    $anchor_m.after($obj);
                    $obj.css("visibility", "visible");
                    var wide = $obj.width();
                    $anchor_m.width($anchor_m.parent().width() - wide);
                    $obj.find(".sticky_buy_items").addClass("closed");
                } else {
                    $obj.removeAttr("style").find(".sticky_buy_items").removeClass("closed opened");
                    $obj_place.before($obj);
                }
            }

            moveSticky();

            $(window).resize(function (e) {
                //check position again
                top = $obj_place.offset().top;
                //is it still mobile?
                mobile = ($(window).width() < 768) ? true : false;

                moveSticky();
            });

            $(window).scroll(function (event) {
                //only do the tracking of position in mobile
                if (mobile) {
                    // what the y position of the scroll is
                    var y = $(this).scrollTop();

                    // whether that's below the form
                    if (y >= top) {
                        // if so, ad the fixed class
                        $obj.addClass('fixed');
                        $obj_place.height($obj.height());

                    }
                    if (y < top) {
                        // otherwise remove it
                        $obj.removeClass('fixed');
                        $obj_place.removeClass('fixed').removeAttr("style");
                    }
                }
            });

            //open menu in desktop
            $(".sticky_buy_item:first-child").click(function (e) {
                e.preventDefault();
                if($(this).parent().hasClass("closed")){
                    $(this).parent().addClass("opened").removeClass('closed');
                } else if ($(this).parent().hasClass("opened")) {
                    $(this).parent().addClass("closed").removeClass('opened');
                }
                //resize menu
                var $anchor_m = $(".anchormenusectionfix.sticky-product-container ul.menu.anchormenu");
                var wide = $obj.width();
                $anchor_m.width($anchor_m.parent().width() - wide);
            });
        }

    });

})(window, document, jQuery);